import "./styles.scss";

import React from "react";
import { useTranslation } from "react-i18next";

import { useApp } from "context/app";

import AnimatedGradient from "components/AnimatedGradient";

import gradient_props from "libs/gradient_props";

const mainClass = "details-card-advice";

const DetailsCardAdvice = ({ value }) => {
  const { t } = useTranslation();
  const { theme } = useApp();

  const { time, seed, colors } = gradient_props.green;

  return (
    <div className={mainClass}>
      <h6>{t("Advice")}</h6>
      <p>{value}</p>
      <div className={`${mainClass}__background`}>
        <AnimatedGradient
          id="advice-gradient"
          time={time}
          seed={seed}
          colors={colors[theme]}
        />
      </div>
    </div>
  );
};

export default DetailsCardAdvice;
